import { useEffect, useState } from 'react';

export const usePageBanners = ({ pageBannerShown, isMonashCollege }) => {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    if (pageBannerShown) {
      import('./constants').then((module) => {
        if (isMonashCollege) {
          setBanners(module.COLLEGE_CONTENT);
        } else {
          setBanners(module.CONTENT);
        }
      });
    }
  }, [pageBannerShown]);

  return banners;
};
